/**
 * @generated SignedSource<<8d7caf301de94d31a0ca1a3360b5022a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccounts_transaction$data = {
  readonly isStripeAchEligible: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutACHFormStripe_transaction" | "CheckoutBankAccountListWrapper_transaction" | "checkoutPayment_transaction">;
  readonly " $fragmentType": "CheckoutBankAccounts_transaction";
};
export type CheckoutBankAccounts_transaction$key = {
  readonly " $data"?: CheckoutBankAccounts_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccounts_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccounts_transaction",
  "selections": [
    {
      "alias": "isStripeAchEligible",
      "args": [
        {
          "kind": "Literal",
          "name": "paymentMethod",
          "value": "ACH"
        },
        {
          "kind": "Literal",
          "name": "paymentProcessor",
          "value": "STRIPE"
        }
      ],
      "kind": "ScalarField",
      "name": "isPaymentMethodEligible",
      "storageKey": "isPaymentMethodEligible(paymentMethod:\"ACH\",paymentProcessor:\"STRIPE\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccountListWrapper_transaction"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutPayment_transaction",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "paymentMethods",
              "value": [
                "PAYPAL_ACCOUNT",
                "WIRE_TRANSFER",
                "ON_PLATFORM_WIRE_TRANSFER",
                "CHECK",
                "ACH",
                "KLARNA"
              ]
            }
          ],
          "kind": "ScalarField",
          "name": "eligiblePaymentMethods",
          "storageKey": "eligiblePaymentMethods(paymentMethods:[\"PAYPAL_ACCOUNT\",\"WIRE_TRANSFER\",\"ON_PLATFORM_WIRE_TRANSFER\",\"CHECK\",\"ACH\",\"KLARNA\"])"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isShippingKnownAtCheckout",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TransactionSummaryObject",
          "kind": "LinkedField",
          "name": "summary",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InvoiceSummary",
              "kind": "LinkedField",
              "name": "invoiceSummary",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Invoice",
                  "kind": "LinkedField",
                  "name": "buyerCurrentInvoice",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FinancialAmount",
                      "kind": "LinkedField",
                      "name": "totalAmount",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "amount",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutACHFormStripe_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "c46f2e6f154e75aae83f24c696db7fd3";

export default node;
